import React from 'react';
import OutlookWidgetBuilder from './OutlookWidgetBuilder';
import OutlookWidgetRenderer from './OutlookWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { OutlookWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

export { default as OutlookWidgetBuilder } from './OutlookWidgetBuilder';
export { default as OutlookWidgetRenderer } from './OutlookWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'outlook',
  meta: {
    label: 'Outlook Email',
    icon: React.createElement(FontAwesomeIcon, { icon: faEnvelope }),
    description: 'Send or compose emails via Outlook',
    isSystem: false,
    isCreatable: true,
    dataFlow: 'input',
  },
  defaultSize: { w: 6, h: 5, minW: 4, minH: 4 },
  defaultConfig: () => ({
    sendMode: 'compose',
    allowEditRecipients: true,
    allowEditSubject: true,
    allowEditBody: true,
  } as OutlookWidgetConfig),
  Builder: OutlookWidgetBuilder,
  Renderer: OutlookWidgetRenderer,
  Preview,
};
